module.exports = __webpack_public_path__ + "static/media/sarkboatstrip.816e6142.jpg";